module.exports = __webpack_public_path__ + "OpenSans-Semibold-9f2144213fad53d4e0fdb26ecf93865f.woff";